import { render, staticRenderFns } from "./InstructorBaseData.vue?vue&type=template&id=7d43c02e"
import script from "./InstructorBaseData.vue?vue&type=script&lang=ts"
export * from "./InstructorBaseData.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports